import React from 'react';
import { BillingTransparencyBlock } from '../../molecules/billing-transparency-block/billing-transparency-block.molecule';
import { Checkout } from '../../../common/types/checkout';
import { CancelAnytimeBlock } from '../../molecules/cancel-anytime-block/cancel-anytime-block.molecule';

type Props = {
  checkout: Checkout;
};

export const ConversionBlock: React.FC<Props> = ({ checkout }) => {
  return (
    <>
      <BillingTransparencyBlock checkout={checkout} />
      <CancelAnytimeBlock checkout={checkout} />
    </>
  );
};
